var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { SetContactsModalData } from './set.contacts.modal.provider';
import { AlertifyService } from '../../../../services/alertify.service';
var SetContactsModalComponent = /** @class */ (function (_super) {
    __extends(SetContactsModalComponent, _super);
    function SetContactsModalComponent(fb, accountApiService, alertify, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.dialogRef = dialogRef;
        _this.account = Object.assign({}, data);
        _this.ensureState();
        return _this;
    }
    Object.defineProperty(SetContactsModalComponent.prototype, "shouldShowSsrDetailAvailabilityToggles", {
        get: function () {
            var hubName = ("" + ((this.account && this.account.account && this.account.account.userName) || ''))
                .trim()
                .toLowerCase();
            return SetContactsModalComponent.SSR_DETAIL_TOGGLE_ROLLOUT_HUBS.indexOf(hubName) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    SetContactsModalComponent.prototype.ngOnInit = function () {
        this.hubContactsForm = this.fb.group({
            name: [null, [Validators.required]],
            number: [null],
            email: [null, [Validators.required]],
            inquiryEmail: [null, null],
            event: [null, null],
            place: [null, null],
            tour: [null, null],
            webhookUrl: [null, null],
            signingSecret: [null, null],
        });
        this.placeForm = this.fb.group({
            dynamicFields: this.fb.array([]),
        });
        for (var _i = 0, _a = this.contact.placeURLs || []; _i < _a.length; _i++) {
            var url = _a[_i];
            this.addPlaceURL(url.igURL, url.clientURL);
        }
    };
    SetContactsModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    SetContactsModalComponent.prototype.save = function (event) {
        var _this = this;
        var array = this.placeForm.get('dynamicFields');
        console.log(array);
        var urls = array.value.filter(function (x) { return x.igURL && x.clientURL; });
        var igDegaulePlaceCategories = [
            'All',
            'Accommodations',
            'Activities',
            'Arts & Culture',
            'Dining & Nightlife',
            'Entertainment',
            'Outdoors',
            'Wellness',
            'Shopping',
            'Transportation',
            'Other',
        ];
        var _loop_1 = function (url) {
            var regex = /\/places\/(?:\w+\/custom|fav\/[a-fA-F0-9]{24})(?:\/|$)/;
            var match = url.igURL.match(regex);
            if (!match && !igDegaulePlaceCategories.any(function (x) { return x === url.igURL; })) {
                this_1.alertify.warning("ImGoing place URL must be ImGoing's default place category (\n            " + igDegaulePlaceCategories.join(', ') + "). \n            <br/><br/>Or custom category in this format: /" + this_1.account.account.userName + "/places/664b3fdcbf671088a01a8322/custom\n            <br/><br/>Or favorite listing in this format: /" + this_1.account.account.userName + "/places/fav/5fb43db62669327fb0615d79", 10);
                setTimeout(function () {
                    var msgbox = document.querySelector('.ajs-message');
                    if (msgbox) {
                        msgbox.style.width = '450px';
                        msgbox.style.right = '490px';
                    }
                });
                event.immediateComplete();
                return { value: void 0 };
            }
        };
        var this_1 = this;
        for (var _i = 0, urls_1 = urls; _i < urls_1.length; _i++) {
            var url = urls_1[_i];
            var state_1 = _loop_1(url);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        this.contact.placeURLs = urls;
        this.webhookSettings.endpointUrl = (this.webhookSettings.endpointUrl || '').trim();
        this.webhookSettings.signingSecret = (this.webhookSettings.signingSecret || '').trim();
        if (this.webhookSettings.enabled) {
            if (!this.webhookSettings.endpointUrl) {
                this.alertify.warning('Webhook URL is required when webhook delivery is enabled.');
                event.immediateComplete();
                return;
            }
            if (!/^https?:\/\//i.test(this.webhookSettings.endpointUrl)) {
                this.alertify.warning('Webhook URL must start with http:// or https://');
                event.immediateComplete();
                return;
            }
            if (!this.webhookSettings.signingSecret) {
                this.alertify.warning('Signing secret is required when webhook delivery is enabled.');
                event.immediateComplete();
                return;
            }
            if (!this.webhookSettings.sendEventDetailInvalidation &&
                !this.webhookSettings.sendEventListingInvalidation &&
                !this.webhookSettings.sendPlaceDetailInvalidation &&
                !this.webhookSettings.sendPlaceListingInvalidation &&
                !this.webhookSettings.sendSsrModuleStatusUpdate) {
                this.alertify.warning('Select at least one webhook subscription before enabling webhook delivery.');
                event.immediateComplete();
                return;
            }
        }
        this.accountApiService
            .setContacts(this.account.account._id, {
            contacts: this.contact,
            webhookSettings: __assign({}, (this.account.account.webhookSettings || {}), { apiUserCacheWebhook: this.webhookSettings }),
        })
            .finally(event.complete)
            .subscribe(function (data) {
            _this.success.success();
            setTimeout(function () {
                _this.dialogRef.close();
            }, 2000);
        });
    };
    SetContactsModalComponent.prototype.addPlaceURL = function (igURL, clientURL) {
        if (igURL === void 0) { igURL = ''; }
        if (clientURL === void 0) { clientURL = ''; }
        var newGroup = this.fb.group({
            igURL: [igURL],
            clientURL: [clientURL],
        });
        this.placeForm.get('dynamicFields').push(newGroup);
    };
    SetContactsModalComponent.prototype.getControls = function () {
        var field = this.placeForm.get('dynamicFields');
        if (field) {
            return field.controls;
        }
        return [];
    };
    SetContactsModalComponent.prototype.generateWebhookSecret = function () {
        var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var secret = '';
        for (var i = 0; i < 48; i++) {
            secret += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        }
        this.webhookSettings.signingSecret = secret;
    };
    SetContactsModalComponent.prototype.ensureState = function () {
        var account = this.account.account || {};
        var contacts = account.contacts || {};
        this.contact = {
            name: contacts.name || '',
            number: contacts.number || '',
            email: contacts.email || '',
            inquiryEmail: contacts.inquiryEmail || '',
            eventsSsrEnabled: !!contacts.eventsSsrEnabled,
            placesSsrEnabled: !!contacts.placesSsrEnabled,
            eventCalendarURL: contacts.eventCalendarURL || '',
            placeCalendarURL: contacts.placeCalendarURL || '',
            moreToursURL: contacts.moreToursURL || '',
            placeURLs: Array.isArray(contacts.placeURLs) ? contacts.placeURLs : [],
        };
        account.contacts = this.contact;
        var webhookSettingsContainer = account.webhookSettings || {};
        var webhookSettings = webhookSettingsContainer.apiUserCacheWebhook || webhookSettingsContainer;
        this.webhookSettings = {
            enabled: !!webhookSettings.enabled,
            endpointUrl: webhookSettings.endpointUrl || '',
            signingSecret: webhookSettings.signingSecret || '',
            sendEventDetailInvalidation: typeof webhookSettings.sendEventDetailInvalidation === 'undefined'
                ? true
                : !!webhookSettings.sendEventDetailInvalidation,
            sendEventListingInvalidation: typeof webhookSettings.sendEventListingInvalidation === 'undefined'
                ? true
                : !!webhookSettings.sendEventListingInvalidation,
            sendPlaceDetailInvalidation: typeof webhookSettings.sendPlaceDetailInvalidation === 'undefined'
                ? true
                : !!webhookSettings.sendPlaceDetailInvalidation,
            sendPlaceListingInvalidation: typeof webhookSettings.sendPlaceListingInvalidation === 'undefined'
                ? true
                : !!webhookSettings.sendPlaceListingInvalidation,
            sendSsrModuleStatusUpdate: typeof webhookSettings.sendSsrModuleStatusUpdate === 'undefined'
                ? true
                : !!webhookSettings.sendSsrModuleStatusUpdate,
        };
        account.webhookSettings = __assign({}, webhookSettingsContainer, { apiUserCacheWebhook: this.webhookSettings });
    };
    SetContactsModalComponent.SSR_DETAIL_TOGGLE_ROLLOUT_HUBS = [
        'randy',
        'savannah2',
        'testwix',
        'newsmyrnabeach',
        'adventurecoast',
    ];
    return SetContactsModalComponent;
}(BaseComponent));
export { SetContactsModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.contacts/set.contacts.modal.component.ts.pre-build-optimizer.js